import React, { memo } from 'react';
import { IconProps } from '.';

type SearchIconProps = { color?: string } & IconProps;

export const SearchIcon: React.FC<SearchIconProps> = memo(
  ({ height = 20, width = 20, color = '#222427' }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 21 20"
      >
        <path
          fill={color}
          d="M13.09 13.95c.32-.27.61-.56.88-.88 0 0 .32-.37.51-.65.88-1.28 1.4-2.83 1.4-4.49C15.88 3.56 12.32 0 7.94 0 3.56 0 0 3.56 0 7.93c0 4.37 3.56 7.93 7.94 7.93 1.67 0 3.22-.52 4.5-1.4l.65-.51zm-5.15 1.08c-3.92 0-7.12-3.19-7.12-7.11C.82 4 4.01.81 7.94.81S15.06 4 15.06 7.92c-.01 3.93-3.2 7.11-7.12 7.11z"
        ></path>
        <path
          fill={color}
          d="M18.61 19.77l-5.74-5.53a.812.812 0 01-.02-1.16c.32-.33.84-.34 1.16-.02l5.74 5.53c.33.32.34.84.02 1.16-.32.33-.84.33-1.16.02z"
        ></path>
      </svg>
    );
  }
);
